import { render, staticRenderFns } from "./SkillsTable.vue?vue&type=template&id=36bd9982&"
import script from "./SkillsTable.vue?vue&type=script&lang=js&"
export * from "./SkillsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports